import { useQuery } from '@tanstack/react-query';
import { supportsFuzzyPatientClientSearch } from '../lib/api';
import { useClinicId } from '../state/auth';

// useSupportsFuzzySearch returns whether the backend supports fuzzy patient/client search for the currently
// logged-in user's clinic. The answer is cached per clinic because a clinic's integration capabilities don't change at
// runtime, but the user can switch clinics within a session.
export const useSupportsFuzzySearch = () => {
  const clinicId = useClinicId();
  const { isPending, error, data } = useQuery<boolean>({
    queryKey: ['supports-fuzzy-patient-client-search', clinicId],
    queryFn: () => supportsFuzzyPatientClientSearch(),
    enabled: !!clinicId,
    staleTime: 1000 * 60 * 60 * 24 // 24 hours
  });

  return {
    isPending,
    error,
    supportsFuzzySearch: data ?? false
  };
};
